<template>
  <b-col>
    <b-card>
      <b-row>
        <b-col sm="12" md="6">
          <b-form-checkbox v-model="pageLayout.enabled"
            >Enabled</b-form-checkbox
          >
        </b-col>
      </b-row>
      <hr />
      <b-row v-if="pageLayout.enabled">
        <b-col>
          <h4>Container</h4>
          <b-row>
            <b-col sm="12" md="6">
              <b-form-group label="Background Color">
                <b-input-group>
                  <b-form-select
                    :options="enumerations"
                    v-model="pageLayout.containerColor"
                  />
                  <b-input-group-append>
                    <theme-helper
                      :theme="theme"
                      :value="pageLayout.containerColor"
                      type="color"
                    />
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
              <b-form-group label="Padding(in pixels)">
                <b-form-input
                  v-model="pageLayout.padding"
                  type="number"
                  min="0"
                  max="100"
                  step="1"
                />
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
              <b-form-group label="Location type">
                <b-form-select v-model="pageLayout.type">
                  <b-form-select-option value="relative"
                    >Relative</b-form-select-option
                  >
                  <b-form-select-option value="fixed"
                    >Fixed</b-form-select-option
                  >
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <h4>Content</h4>
          <b-form-textarea v-model="pageLayout.content" />
          <hr />
        </b-col>
      </b-row>
      <b-button
        variant="primary"
        @click="$emit('saved', { key: 'actionbar', config: { ...pageLayout } })"
        >Save</b-button
      >
    </b-card>
  </b-col>
</template>

<script>
import { enumerations, shapeStyles, textSizeOptions } from "@/utils/constants";
import ThemeHelper from "@/components/layout-editor/themeHelper";

export default {
  name: "footerTab",
  components: { ThemeHelper },
  props: ["pageLayout", "theme"],
  data: () => ({
    show: false,
    textSizeOptions,
    enumerations,
    shapeStyles,
  }),
};
</script>

<style scoped></style>
